import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home8 from "./Pages/Home8";
import Home2 from "./Pages/Home2";

import About1 from "./Pages/About1";
import About2 from "./Pages/About2";
import Account from "./Pages/Account";

import OurHistory from "./Pages/OurHistory";
import FontIcons from "./Pages/FontIcons";
import Error from "./Pages/Error";

import ProjectCorousel from "./Pages/ProjectCorousel";
import ProjectDetail1 from "./Pages/ProjectDetail1";
import ProjectDetail2 from "./Pages/ProjectDetail2";

import BlogGrid from "./Pages/BlogGrid";
import PostRightSidebar from "./Pages/PostRightSidebar";

import ContactUs from "./Pages/ContactUs";
import ScrollToTop from "./Common/ScrollToTop";
import Service2 from "./Pages/Services2";
import TeamDetail from "./Pages/TeamDetail";
import ShopCheckout from "./Pages/ShopCheckout";
import ShopList from "./Pages/ShopList";

class Components extends React.Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <ScrollToTop />
        <div className="page-wraper">
          <Routes>
            <Route path="/" element={<Home2 />} />
            <Route path="/home-2" element={<Home8 />} />

            <Route path="/about-1" element={<About1 />} />
            <Route path="/organisations" element={<About2 />} />
            {/* <Route path="/nous-rejoindre" element={<About3 />} /> */}
            <Route path="/nous-rejoindre" element={<Service2 />} />

            <Route path="/our-history" element={<OurHistory />} />
            <Route path="/icon-font" element={<FontIcons />} />
            <Route path="/error-404" element={<Error />} />

            <Route path="/projets" element={<ProjectCorousel />} />
            <Route path="/projects/valle-or-1" element={<ProjectDetail1 />} />
            <Route path="/project-detail2" element={<ProjectDetail2 />} />

            <Route path="/annonces" element={<BlogGrid />} />
            {/* <Route path="/account" element={<TeamDetail />} /> */}
            <Route path="/account" element={<Account />} />
            <Route path="/account/edit" element={<ShopCheckout />} />
            <Route path="/account/annonces" element={<ShopList />} />
            <Route
              path="/annonces/valle-val-or-1"
              element={<PostRightSidebar />}
            />
            <Route path="/contact-us" element={<ContactUs />} />

            <Route path="*" element={<Error />} />
          </Routes>
        </div>
      </BrowserRouter>
    );
  }
}

export default Components;
